/**
 * Liste canonique des thèmes visuels de l'interface (passée telle quelle à la
 * prop `themes` du `ThemeProvider` next-themes). Source unique de vérité :
 * `ThemePicker`, la carte « Style » d'`AccountPreferences`, et la validation
 * de `profiles.ui_theme` en dérivent tous leurs libellés/options depuis ce
 * tableau plutôt que de les lister en dur — ajouter un thème plus tard se
 * limite à une entrée ici + un bloc CSS correspondant dans index.css, nommé
 * exactement comme l'id (`.coral {}`, pas `.theme-coral` — next-themes avec
 * attribute="class" applique le nom du thème tel quel comme classe sur
 * <html>, sur le modèle de `.dark {}`).
 */
export const UI_THEMES = ["dark", "coral", "periwinkle"] as const;

export type UiThemeId = (typeof UI_THEMES)[number];

export function isUiThemeId(value: string): value is UiThemeId {
  return (UI_THEMES as readonly string[]).includes(value);
}
